import { render, staticRenderFns } from "./ultimScore2.vue?vue&type=template&id=1bc3389d&scoped=true&"
import script from "./ultimScore2.vue?vue&type=script&lang=js&"
export * from "./ultimScore2.vue?vue&type=script&lang=js&"
import style0 from "./ultimScore2.vue?vue&type=style&index=0&id=1bc3389d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc3389d",
  null
  
)

export default component.exports